import { ArrowRight, Play } from 'lucide-react';

import Container from './Container';
import Reveal from '../../../components/Reveal';
import heroDevice from './../../../assets/images/hero-device.png';

const REGISTER_URL = 'https://app.schoolhack.ai/auth/register';

const Hero = () => {
  return (
    <section className="relative overflow-hidden pb-16 pt-14 md:pt-40 lg:pb-52">
      {/* ambient */}
      <div className="glow left-1/2 top-[-140px] h-[420px] w-[620px] -translate-x-1/2 bg-accent/16" />
      <div className="glow right-[-120px] top-[120px] h-[360px] w-[360px] bg-accent/10" />
      <div className="pointer-events-none absolute inset-0 grid-overlay opacity-60" />

      <Container className="relative grid items-center gap-0 lg:grid-cols-[1.05fr_1fr]">
        {/* Left copy */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <Reveal>
            <span className="eyebrow">
              <span className="h-1.5 w-1.5 rounded-full bg-accent" />
              Trusted by 3.5M+ students worldwide
            </span>
          </Reveal>

          <Reveal delay={80}>
            <h1 className="font-heading mt-6 text-[2.6rem] font-bold leading-[1.05] text-white sm:text-[3.4rem] lg:text-[4rem]">
              <span className="head-fade">Learn Smarter</span>
              <br />
              With <span className="text-accent-grad">School Hack</span>
            </h1>
          </Reveal>

          <Reveal delay={160}>
            <p className="mt-6 w-full max-w-[28rem] text-[0.98rem] leading-relaxed text-white/60">
              School Hack helps you grasp topics, study for exams, and boost your
              confidence.
            </p>
          </Reveal>

          <Reveal delay={240}>
            <div className="mt-8 flex w-full flex-col items-center gap-3 sm:flex-row lg:w-auto">
              <a
                href={REGISTER_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-primary w-full px-7 py-3.5 text-[0.95rem] sm:w-auto"
              >
                Sign up for free
                <ArrowRight size={17} />
              </a>
              <a
                href="#everything"
                className="btn-ghost w-full px-7 py-3.5 text-[0.95rem] sm:w-auto"
              >
                <Play size={15} className="text-accent" />
                See How It Works
              </a>
            </div>
          </Reveal>
        </div>

        {/* Right — real laptop + phone device render */}
        <Reveal
          delay={200}
          className="relative mx-auto w-full max-w-[840px] lg:-ml-[15%] lg:mr-0 lg:w-[115%] lg:max-w-none xl:-ml-[25%] xl:w-[125%]"
        >
          <div className="glow left-1/2 top-1/2 h-[640px] w-[860px] -translate-x-1/2 -translate-y-1/2 bg-accent/16" />
          <img
            src={heroDevice}
            alt="School Hack app on laptop and phone"
            className="relative w-full animate-float-slow object-contain drop-shadow-[0_40px_80px_rgba(0,0,0,0.55)]"
          />
        </Reveal>
      </Container>
    </section>
  );
};

export default Hero;
